export enum LoginFormView {
  Login = 1,
  ForgotPassword = 2,
  ForgotUsername = 3,
  EmailSentForgotPassword = 4,
  EmailSentForgotUsername = 5,
}
